module.exports = __webpack_public_path__ + "static/media/8_Luccy_T@2x.57bfd99d.jpg";